import React from "react";
import welcomeGif from "../../../resources/images/81107-welcome.gif";
const WelcomePage = () => {
  return (
    <div className="empty-state">
      <div
        className="empty-state__content"
        style={{ margin: "0px", marginTop: "5%" }}
      >
        <div style={{ flexDirection: "column" }} className="empty-state__icon">
          <img
            src={welcomeGif}
            alt=""
            style={{ width: "500px", height: "500px" }}
          />
          {<h1>Welcome to ATS</h1>}
          <div className="dashboard-text">
            There is no data to display.
            <br /> You can start creating openings followed by respective
            applicants
          </div>
        </div>
      </div>
    </div>
  );
};
export default WelcomePage;
